import { render, staticRenderFns } from "./topic-loading.vue?vue&type=template&id=5ae13288&scoped=true&"
var script = {}
import style0 from "./topic-loading.vue?vue&type=style&index=0&id=5ae13288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae13288",
  null
  
)

export default component.exports